const setScript = script => {
  if (script) {
    const fragment = document.createRange().createContextualFragment(script)
    document.body.append(fragment)
  }
}

export default setScript
